import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../common/types/RecordType";
import { useOnPremAssetDetails } from "../common/hooks/useOnPremAssetDetails";
import { OnPremAudioTechnicalSection } from "./audio/OnPremAudioTechnicalSection";
import { OnPremVideoTechnicalSection } from "./video/OnPremVideoTechnicalSection";

export const OnPremTechnicalSection: React.FunctionComponent = () => {
    const { data: assetDetails, isLoading } = useOnPremAssetDetails();

    switch (assetDetails?.type) {
        case RecordType.Video:
            return (
                <OnPremVideoTechnicalSection
                    technical={assetDetails.technical}
                    isLoading={isLoading}
                    style={{ height: 450 }}
                />
            );

        case RecordType.Audio:
            return (
                <OnPremAudioTechnicalSection
                    technical={assetDetails.technical}
                    isLoading={isLoading}
                    style={{ height: 450 }}
                />
            );

        case RecordType.Subtitle:
            return <></>;

        default:
            return <ContentSection header="Technical" isLoading={true} style={{ height: 450 }} />;
    }
};
